module.exports = __webpack_public_path__ + "img/htm.502e690c.svg";